const STATUS = {
  RECEIVED: 'received',
  PICKED: 'being picked',
  DISPATCHED: 'awaiting dispatch',
  EN_ROUTE: 'enroute',
  DELIVERED: 'delivered',
};

export default STATUS;



// WEBPACK FOOTER //
// src/components/atoms/Status/index.jsx